module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-oneup-corda-02.95b0c9d1.jpg";